import React from 'react';
import Premium from '../../assets/icons/png/Premium.png';
import ArrowVerifyIconSVG from '../../assets/icons/svg/ArrowVerifyIconSVG';

const HomePage = ({ user, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();  
    }
  };

  return (
    <div style={styles.wrapper} onClick={handleClick}>
      <div style={styles.iconBox}>
        <img src={Premium} alt="premium" style={styles.icon} />
      </div>
      <div style={styles.textBox}>
        <div style={styles.titleRow}>
          <div style={styles.title}>Aktiviraj Premium Paket za još modela</div>
          <ArrowVerifyIconSVG />
        </div>
        <div style={styles.description}>
          Iskoristi sve prednosti naprednih opcija, direktno komuniciraj sa kupcima i povećaj svoju prodaju
        </div>
      </div>
    </div>
  );
};

export default HomePage;

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '6px',
    cursor: 'pointer',
    width: '430px',
    gap: '20px',
    border: '2px solid rgba(91, 33, 182, 1)',
    backgroundColor: 'rgba(245, 245, 244, 1)',
    minHeight: '320px',
  },
  iconBox: {
    width: '195px',
    height: '160px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '20px',
  },
  textBox: {
    width: '100%',
    padding: '0',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  title: {
    color: 'rgba(91, 33, 182, 1)',
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '0.2px',
    textAlign: 'left',
    lineHeight: '20px',
    flex: 1,
    marginRight: '12px',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '16px',
    fontWeight: '400',
    textAlign: 'left',
    lineHeight: '24px',
  },
};
